import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=1a4069d6&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4069d6",
  null
  
)

export default component.exports